import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { WindowProxy } from '@sm360/widget-commons-core-services';
import { HistoryService } from '@sm360/widget-commons-general';

import InstantEstimateProvider from 'trade-in-360/InstantEstimateProvider.jsx';

// Embedded version
class TradeInProvider extends Component {
    componentDidMount() {
        const $window = WindowProxy.get();
        if ($window) {
            $window.addEventListener('beforeunload', this.onUnload);
        }
    }

    componentWillUnmount() {
        this.onUnload();
    }

    onUnload() {
        HistoryService.add(WindowProxy.location().href);
    }

    render() {
        return <InstantEstimateProvider {...this.props} isModal />;
    }
}

TradeInProvider.displayName = 'TradeInProvider';

TradeInProvider.defaultProps = {
    onTradeInSuccess: noop,
};

TradeInProvider.propTypes = {
    locale: PropTypes.string.isRequired,
    websiteId: PropTypes.number.isRequired,
    organizationUnitId: PropTypes.number.isRequired,
    organizationId: PropTypes.number.isRequired,
    organizationUnitLocation: PropTypes.string.isRequired,
    onTradeInSuccess: PropTypes.func,
    contentZones: PropTypes.objectOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                active: PropTypes.bool,
                group: PropTypes.string,
                id: PropTypes.number,
                location: PropTypes.string,
                position: PropTypes.number,
                type: PropTypes.string,
                value: PropTypes.string,
            })
        )
    ).isRequired,
};

export default TradeInProvider;
